$(function () {

    var accordionBlocks = $('.accordion_block');

    if (accordionBlocks.length < 1) {
        return;
    }

    // Icons
    var openIcon = '<svg class="open" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>';

    var closeIcon = '<svg class="close close--hidden" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>';

    // Hide all accordion items
    $('.accordion_block__accordion_item__content').addClass('accordion_block__accordion_item__content--hidden');

    // The big boi stuff
    accordionBlocks.each(function () {

        // Define accordion items
        var accordionItems = $(this).children('.accordion_block__accordion_item');

        accordionItems.each(function () {
            // Append icons
            var iconWrapper = $(this).find('.accordion_block__accordion_item__title__icon');

            iconWrapper.append(openIcon);
            iconWrapper.append(closeIcon);

            // Make it work
            var title = $(this).find('.accordion_block__accordion_item__title');
            var content = $(this).find('.accordion_block__accordion_item__content');
            var iconClose = iconWrapper.children('.close');
            var iconOpen = iconWrapper.children('.open');

            title.on('click', function (e) {

                // Prevent the default action
                e.preventDefault();

                // Close them all first!
                accordionItems.find('.accordion_block__accordion_item__content').not(content).slideUp();
                accordionItems.find('.accordion_block__accordion_item__title__icon .close').not(iconClose).addClass('close--hidden');
                accordionItems.find('.accordion_block__accordion_item__title__icon .open').not(iconOpen).removeClass('open--hidden');
                accordionItems.find('.accordion_block__accordion_item__title').not($(this)).removeClass('active');

                // Open the current one
                $(this).toggleClass('active');
                if ($(this).hasClass('active')) {
                    content.slideDown();
                    iconClose.toggleClass('close--hidden');
                    iconOpen.toggleClass('open--hidden');
                } else {
                    content.slideUp();
                    iconClose.toggleClass('close--hidden');
                    iconOpen.toggleClass('open--hidden');
                }
            });
        });

    });

});